import * as React from 'react';
import Keycloak, { type KeycloakLoginOptions } from 'keycloak-js';
import type { AuthContextType, User } from '../../types/auth.types';
import { AuthContext } from './AuthContext';


interface AuthProviderProps {
    keycloakClient: Keycloak;
    children: React.ReactNode;
}

const AuthProvider = ({ keycloakClient, children }: AuthProviderProps) => {
    const [user, setUser] = React.useState<User | undefined>(undefined);

    React.useEffect(() => {
        //Synchronize entry
        if (keycloakClient.authenticated) {
            const user: User = {
                email: keycloakClient.tokenParsed?.email,
                givenNames: keycloakClient.tokenParsed?.given_name,
                lastName: keycloakClient.tokenParsed?.family_name
            };
            setUser(user);
        } else {
            setUser(undefined);
        }

    }, [keycloakClient]);


    const login = async (options?: KeycloakLoginOptions) => {
        return keycloakClient.login(options);
    };

    const logout = async () => {
        const url = keycloakClient.createLogoutUrl({ redirectUri: window.location.origin + '/' });
        window.location.replace(url);
        return Promise.resolve()
    };

    const register = async () => {
        return keycloakClient.register();
    };

    const accountManagement = async () => {
        return keycloakClient.accountManagement();
    };

    const value: AuthContextType = {
        user,
        login,
        logout,
        register,
        accountManagement
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;